import { Center, Divider } from '@mantine/core';
import StepResultsCard from '@/pages/Run/components/StepResultsCard.tsx';
import {
  ParentStepRun,
  RetainedPriorScopeStepRun,
  StepRun,
  WaitingStepDependency,
} from '@/types/stepExecutions.ts';
import { Run } from '@/types/runs.ts';
import { AutomationStep } from '@/types/automationSteps.ts';
import { StepDisabledInfo } from '@/utils/stepUtils.ts';
import { AutoExpandPlan } from '@/types/autoExpandPlan.ts';
import { ChildScopeContext } from '@/pages/Run/components/ScopeStack/childScopeModel.ts';

type props = {
  stepRuns: StepRun[];
  retainedPriorScope?: RetainedPriorScopeStepRun;
  run: Run;
  step: AutomationStep;
  index: number;
  parentSteps: ParentStepRun[];
  stepsById: Record<string, AutomationStep>;
  isLastStep: boolean;
  allowHistoricalStepRuns?: boolean;
  disabledInfo?: StepDisabledInfo;
  waitingDependencies: WaitingStepDependency[];
  autoExpandPlan?: AutoExpandPlan | null;
  childScopePresentation?: 'inline' | 'horizontal';
  onOpenChildScope?: (context: ChildScopeContext, isHistorical?: boolean) => void;
  onChildScopeContextChange?: (context: ChildScopeContext) => void;
  activeScopeParentStepRunId?: string;
};

const StepExecutionRenderer = ({
  run,
  step,
  stepRuns,
  retainedPriorScope,
  index,
  isLastStep,
  parentSteps,
  stepsById,
  allowHistoricalStepRuns = false,
  disabledInfo,
  waitingDependencies,
  autoExpandPlan,
  childScopePresentation,
  onOpenChildScope,
  onChildScopeContextChange,
  activeScopeParentStepRunId,
}: props) => {
  return (
    <>
      <StepResultsCard
        run={run}
        step={step}
        stepRuns={stepRuns}
        retainedPriorScope={retainedPriorScope}
        index={index}
        parentSteps={parentSteps}
        allowHistoricalStepRuns={allowHistoricalStepRuns}
        stepsById={stepsById}
        disabledInfo={disabledInfo}
        waitingDependencies={waitingDependencies}
        autoExpandPlan={autoExpandPlan}
        childScopePresentation={childScopePresentation}
        onOpenChildScope={onOpenChildScope}
        onChildScopeContextChange={onChildScopeContextChange}
        activeScopeParentStepRunId={activeScopeParentStepRunId}
      />
      {!isLastStep && (
        <Center>
          <Divider
            orientation={'vertical'}
            h={childScopePresentation === 'horizontal' ? '12px' : '20px'}
            size={'1px'}
            c={'#ECECED'}
          />
        </Center>
      )}
    </>
  );
};

export default StepExecutionRenderer;
